import { render, staticRenderFns } from "./CardKpiDashboard.vue?vue&type=template&id=c4a24f6e&scoped=true&"
import script from "./CardKpiDashboard.vue?vue&type=script&lang=js&"
export * from "./CardKpiDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CardKpiDashboard.vue?vue&type=style&index=0&id=c4a24f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a24f6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
